// import { Facebook, Instagram, Twitter } from '@mui/icons-material'
import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import PhoneIcon from '@mui/icons-material/Phone';
import "./SotialIcon"
// import Snapchat from './../../assets/Icon/Snapchat.png'
function SotialIcon() {
    return (
        <Stack direction="column" gap={1} justifyContent={"space-evenly"} alignItems={'center'} margin={"0 5%"}  >
            <Box >
                <Link
                    to="tel:+97431555067"
                    style={{
                        color: "inherit",
                        textDecoration: "none",
                        fontSize: 15,
                        fontWeight: "bold",
                    }}
                ><Box sx={{ display: 'flex', gap: 2, width: '100%' }} >
                        <Typography sx={{ fontSize: '1.5rem' }} ><PhoneIcon sx={{ fontSize: '2.5rem', color: '#FFF' }} /></Typography>
                        <Box alignItems={'flex-start'} display={'flex'} >
                            <Typography sx={{ fontSize: '1.5rem', color: '#FFF' }}>+97431555067</Typography>
                        </Box>
                    </Box>
                    {/* <Facebook sx={{ fontSize: '4rem', color: '#FFF' }} /> */}
                </Link>
            </Box>
            <Box >
                <Link
                    to="tel:+97450030665"
                    style={{
                        color: "inherit",
                        textDecoration: "none",
                        fontSize: 15,
                        fontWeight: "bold",
                    }}
                > <Box sx={{ display: 'flex', gap: 2, width: '100%' }} >
                        <Typography sx={{ fontSize: '1.5rem' }} ><PhoneIcon sx={{ fontSize: '2.5rem', color: '#FFF' }} /></Typography>
                        <Box alignItems={'flex-start'} display={'flex'} >
                            <Typography sx={{ fontSize: '1.5rem', color: '#FFF' }}>+97450030665</Typography>
                        </Box>
                    </Box>

                    {/* <svg fill="#ffffff" viewBox="0 0 256 256" id="Flat" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff" style={{ width: '40px' }} ><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M249.36426,186.78713a11.9214,11.9214,0,0,0-6.76856-8.958c-1.3872-.66748-25.52636-12.74414-38.49853-48.14355l16.35986-6.544a12,12,0,0,0-8.91406-22.2832L198.04,106.25979A162.8006,162.8006,0,0,1,196,80,68,68,0,0,0,60,80a162.78977,162.78977,0,0,1-2.04,26.25928l-13.50342-5.40088a11.99983,11.99983,0,0,0-8.91308,22.2832l16.35986,6.54346c-12.93359,35.293-36.96582,47.40381-38.48535,48.13721a12.00069,12.00069,0,0,0-3.10742,19.61035c8.21582,7.71094,19.24609,8.44726,28.97754,9.09765,5.09472.33985,10.86816.72559,13.584,2.22071,2.59131,1.42578,5.94434,6.02246,8.90234,10.07715,5.51661,7.5625,12.38184,16.97363,23.479,19.81347a26.73407,26.73407,0,0,0,6.65771.8291c8.19825,0,15.83789-3.56054,22.74854-6.78125C119.60742,230.38381,124.72266,228,128,228s8.39355,2.38379,13.34082,4.68945c8.74951,4.07715,18.665,8.70508,29.40723,5.95118,11.0957-2.83887,17.96093-12.25,23.47754-19.81153,2.958-4.05566,6.311-8.65234,8.90234-10.07812,2.71582-1.49512,8.49023-1.88086,13.584-2.22071,9.73194-.65039,20.76172-1.38671,28.978-9.09765A11.99019,11.99019,0,0,0,249.36426,186.78713Zm-57.81006.93848c-7.26367,3.998-12.28662,10.88379-16.71826,16.959-3.25147,4.457-7.29785,10.00488-10.03711,10.70508-2.42725.61816-8.72363-2.31152-13.32031-4.4541C144.502,207.68459,136.59473,204,128,204s-16.50195,3.68457-23.478,6.93555c-4.59619,2.14355-10.88623,5.07422-13.31982,4.45508-2.74024-.70118-6.78662-6.249-10.03809-10.70606-4.43164-6.07519-9.4541-12.96-16.71728-16.959-5.75537-3.168-12.252-4.21485-18.43067-4.76172C63.22314,165.9717,84,134.22756,84,80a44,44,0,0,1,88,0c0,54.22754,20.77686,85.97168,37.98438,102.96387C203.80566,183.51076,197.30957,184.55764,191.5542,187.72561Z"></path> </g></svg> */}
                    {/* <CardMedia
                        height={50}
                        sx={{ objectFit: 'contain' }}
                        component="img"
                        image={Snapchat}
                        alt="green iguana"
                    /> */}
                </Link>
            </Box>
            {/* <Box >
                <Link
                    to="https://www.instagram.com/theprofessorgeneralcontracting/"
                    style={{
                        color: "inherit",
                        textDecoration: "none",
                        fontSize: 15,
                        fontWeight: "bold",
                    }}
                >
                    <Instagram sx={{ fontSize: '4rem', color: '#FFF' }} />
                </Link>
            </Box>
            <Box >
                <Link
                    to="https://twitter.com/TheProfess37451"
                    style={{
                        color: "inherit",
                        textDecoration: "none",
                        fontSize: 15,
                        fontWeight: "bold",
                    }}
                >
                    <Twitter sx={{ fontSize: '4rem', color: '#FFF' }} />
                </Link>
            </Box> */}
        </Stack>
    )
}

export default SotialIcon